import { useCallback, useEffect, useState } from 'react';
import { CLOSE_ANIMATION_DURATION, DEFAULT_TOAST_DURATION } from './constants';
import { useCloseToast } from './hooks';
import { ToastPresentation } from './presentation';
import styles from './styles.module.scss';

type Props = {
  toastId: string;
  isDeletable?: boolean;
  duration?: number;
} & Omit<React.ComponentProps<typeof ToastPresentation>, 'onClickClose' | 'isClosing'>;

export const Toast: React.FC<Props> = ({
  toastId,
  message,
  status = 'success',
  isDeletable = false,
  duration = DEFAULT_TOAST_DURATION,
}) => {
  const { closeToast } = useCloseToast();
  const [isClosing, setIsClosing] = useState(false);

  const startCloseAnimation = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => closeToast(toastId), CLOSE_ANIMATION_DURATION);
  }, [closeToast, toastId]); // 依存配列に必要な値を指定

  useEffect(() => {
    const interval = setInterval(startCloseAnimation, duration);

    return () => clearInterval(interval);
  }, [startCloseAnimation, duration]);

  return (
    <div className={`${styles.animationWrapper} ${isClosing ? styles.isClosing : ''}`}>
      <ToastPresentation
        message={message}
        status={status}
        onClickClose={isDeletable ? startCloseAnimation : undefined}
        isClosing={isClosing}
      />
    </div>
  );
};
